import {
    Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle,
    FormControlLabel, TextField, Typography
} from "@mui/material";
import { getKeyScopeById, updateKeyScopeQuota } from "api/layer";
import { AppAction, AppContext } from "helpers/context";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./quota-modal.module.scss";

interface Props {
    open: boolean;
    onClose: () => void;
    data?: FormData;
}

interface FormData {
    id?: string;
    clientId: string;
    keyCode: string;
    aud: string | null;
    scope: string;
    jtl: string | null;
    iss: string | null;
    startTime: any;
    endTime: any;
}

function QuotaModal(props: Readonly<Props>) {
    const [t] = useTranslation();
    const [context, dispatch] = useContext(AppContext);
    const [quotasList, setQuotasList] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false);

    const handleChange = (event: any, scopeId: any) => {
        const { name, value, type, checked } = event.target;
        setQuotasList(quotasList.map((item) => {
            if (item.scopeId === scopeId) {
                let val;
                if (type === "checkbox") {
                    val = checked;
                } else if (name === "totalQuota") {
                    val = value * 1;
                } else {
                    val = value;
                }
                item[name] = val
            }
            return item
        }));
    }

    const close = () => {
        props.onClose();
    };

    const handleSave = () => {
        let param = {
            keyId: props.data?.id,
            subQuotas: quotasList.filter(item => item.config)
        }

        updateKeyScopeQuota(param)
            .then((res: any) => {
                if (res && res.code === 200) {
                    props.onClose();
                    dispatch({
                        type: AppAction.addSnackBarParams,
                        payload: {
                            title: "updateKeyScopeQuota",
                            message: "updateKeyScopeQuotaSuccess",
                        },
                    });
                } else {
                    dispatch({
                        type: AppAction.addSnackBarParams,
                        payload: {
                            title: "updateKeyScopeQuota",
                            titleIconColor: "yellow",
                            titleIcon: "warning",
                            resMessage: res.message,
                        },
                    });
                }
            })
    };

    const initData = () => {
        if (!props.data?.id) {
            return;
        }

        setLoading(true);

        getKeyScopeById(props.data.id)
            .then(res => {
                setQuotasList(res.data?.filter((item: any) => item.config) || []);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(() => {
        initData();
    }, [props.data]);


    return (
        <Dialog
            open={props.open}
            onClose={close}
        >
            <DialogTitle
                sx={{
                    fontWeight: 600,
                    fontSize: "16px",
                    opacity: 0.79,
                    color: "#333",
                    width: "400px",
                }}
            >
                {props.data?.keyCode}
            </DialogTitle>
            {loading ? (
                <div className={styles.loading}>
                    <div className="loading loading-spinner loading-lg"></div>
                    <div>{t("layers.loading")}</div>
                </div>
            ) : (
                <DialogContent
                    sx={{
                        overflowY: "auto",
                        "&::-webkit-scrollbar": { width: "8px" },
                        "&::-webkit-scrollbar-thumb": { backgroundColor: "#888", borderRadius: "4px" },
                        "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#555" },
                        "&::-webkit-scrollbar-track": { background: "#f1f1f1" },
                    }}
                >
                    <div className={styles.section}>
                        <Typography style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "10px" }}>{t("permissionConfig.title1")}</Typography>
                        {quotasList.map((item: any) =>
                            <div style={{ padding: "0 0 10px 10px", display: "flex", alignItems: "center" }} key={item.scopeId}>
                                <label style={{ flex: 1 }}>{item.scopeName}</label>
                                <TextField
                                    color="success"
                                    variant="outlined"
                                    value={item.totalQuota}
                                    name="totalQuota"
                                    onChange={(event) => handleChange(event, item.scopeId)}
                                    size="small"
                                    style={{ marginLeft: 16, flex: 1 }}
                                    type="number"
                                    inputProps={{
                                        step: 1,
                                        min: 0,
                                        max: 10000000,
                                    }}
                                />
                            </div>)}
                    </div>
                </DialogContent>
            )
            }
            <DialogActions>
                <Button
                    onClick={close}
                    color="success"
                >
                    {t("buttons.cancel")}
                </Button>
                <Button
                    onClick={handleSave}
                    color="success"
                    variant="contained"
                >
                    {t("buttons.save")}
                </Button>
            </DialogActions>
        </Dialog >
    );
}

export default QuotaModal;
